import axios, { AxiosError, AxiosResponse } from 'axios'
import Cookies from 'js-cookie'

import { apiBaseUrl, apiKey, pickupApiBaseUrl, pickupApiKey } from '~/configs/app'

const handleResponse = (response: AxiosResponse) => response
const handleError = (error: AxiosError) => Promise.reject(error)

const getAccessToken = () => Cookies.get('access_token')

/* Private instance */
const api = axios.create({
  baseURL: apiBaseUrl,
})

api.interceptors.request.use((config) => {
  try {
    const token = getAccessToken()
    config.headers.Authorization = token ? `Bearer ${token}` : ''
    config.headers['X-API-KEY'] = apiKey
    return config
  } catch (error) {
    console.error('Failed to retrieve token:', error)
    return config
  }
})

api.interceptors.response.use(handleResponse, (error: AxiosError) => {
  if (error.response?.status === 401) {
    // handle error and maybe refresh token here
  }
  return handleError(error)
})

/* Public instance */
const publicApi = axios.create({
  baseURL: apiBaseUrl,
})

publicApi.interceptors.request.use((config) => {
  config.headers['X-API-KEY'] = apiKey
  return config
})

publicApi.interceptors.response.use(handleResponse, handleError)

/* jba-web-api instance — unit pickup Kode Unik validate/redeem (App-Token shared secret, not X-API-KEY) */
const pickupApi = axios.create({
  baseURL: pickupApiBaseUrl,
})

pickupApi.interceptors.request.use((config) => {
  config.headers['App-Token'] = pickupApiKey
  return config
})

pickupApi.interceptors.response.use(handleResponse, handleError)

export { api, pickupApi, publicApi }
